// extracted by mini-css-extract-plugin
module.exports = {"collapseItem":"FormMobile_collapseItem__1tX4z"};